import { gql } from '@apollo/client';

export const REGULAR_HEALTH_CHECKUP_REPORT = gql`
  query regularHealthCheckupReport($id: Int!) {
    regularHealthCheckupReport(id: $id) {
      id
      office {
        id
        name
      }
      officeSnapshot {
        id
        name
        postcode0
        postcode1
        prefecture {
          id
          name
        }
        city
        houseNumber
        building
        addressKana
        phoneNumber0
        phoneNumber1
        phoneNumber2
      }
      title
      businessType {
        id
        name
      }
      aggregationOffices {
        id
        name
      }
      startOn
      endOn
      reportNumber
      healthCheckupInstitution {
        id
        healthCheckupInstitutionId
        name
        location
      }
      specifiedWorkSummaries {
        id
        specifiedWorkCode
        count
      }
      resultSummaries {
        id
        itemCode
        totalCount
        hasFindingCount
      }
      physicianName
      physicianInstitutionName
      physicianInstitutionAddress
      submitOn
      egovProcedureSendable
    }
  }
`;

export interface RegularHealthCheckupReport {
  id: string;
  office?: {
    id: string;
    name: string;
  };
  officeSnapshot?: {
    id: string;
    name: string;
    postcode0: string;
    postcode1: string;
    prefecture?: {
      id: string;
      name: string;
    };
    city: string;
    houseNumber: string;
    building: string;
    addressKana: string;
    phoneNumber0: string;
    phoneNumber1: string;
    phoneNumber2: string;
  };
  title: string;
  businessType?: {
    id: string;
    name: string;
  };
  aggregationOffices?: AggregationOffice[];
  startOn: string;
  endOn: string;
  reportNumber: string;
  healthCheckupInstitution: {
    id: string;
    healthCheckupInstitutionId: string;
    name: string;
    location: string;
  };
  specifiedWorkSummaries?: SpecifiedWorkSummary[];
  resultSummaries?: ResultSummary[];
  physicianName: string;
  physicianInstitutionName: string;
  physicianInstitutionAddress: string;
  submitOn: string;
  egovProcedureSendable: boolean;
}

export interface AggregationOffice {
  id: string;
  name: string;
}

export interface SpecifiedWorkSummary {
  id: string;
  specifiedWorkCode: string;
  count: string;
}

export interface ResultSummary {
  id: string;
  itemCode: string;
  totalCount: string;
  hasFindingCount: string;
}
